import {
  Text,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Grid,
  Flex,
  Button
} from '@chakra-ui/react'
import { FC } from 'react'
import { BsClipboardData } from 'react-icons/bs'

import LayoutEmpty from '@component/Layout/Empty'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'

import {
  ITableGridAction,
  ITableHeader
} from '@base/@types/components/Layout/TableGrid'

import ConfigColumnModal from './ConfigColumnModal'

interface IColumn {
  id: string
  name: string
  show: boolean
}

export interface IkpiModalTableStructure {
  group: string
  columns: IColumn[]
}

export interface Pagination {
  actualPage: string | number
  rows: string | number
  totalPages: string | number
  totalRows: string | number
  skip: string | number
}

interface ISalesModalProps {
  id: string
  entity: string
  data: any[]
  isOpen: boolean
  onClose: () => void
  headers: ITableHeader[]
  query: string
  isExport?: boolean
  itsSortable: boolean
  isPaged: boolean
  isLoadingExport?: boolean
  loadingModal: boolean
  isModalConfig?: boolean
  actions: ITableGridAction[]
  updateIsModalConfig?: () => void
  onChange?: (index: number, column: number) => void
  onClickExport?: () => void
  kpiModalTableStructure: IkpiModalTableStructure[]
  isDisabled?: (columnId: string) => boolean
  handlePageChange?: (page: number) => void
  udatePageChange?: (page: number) => void
  pagination?: Pagination
  isPagedBack?: boolean
}

const KpiModal: FC<ISalesModalProps> = ({
  id,
  data,
  query,
  entity,
  isOpen,
  actions,
  headers,
  isPaged,
  onClose,
  onChange,
  isExport = false,
  pagination,
  isDisabled,
  isPagedBack,
  itsSortable,
  loadingModal,
  isModalConfig,
  onClickExport,
  udatePageChange,
  isLoadingExport,
  handlePageChange,
  updateIsModalConfig,
  kpiModalTableStructure
}) => {
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
        <ModalOverlay />
        <ModalContent background={'white'} marginX={[4, 8, 16]}>
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={'gray.200'}
            background={'#1d5840'}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex alignItems="center">
              <BsClipboardData />
              <Text marginLeft={2}>KPI</Text>
              {isExport && (
                <>
                  <Flex marginLeft={2} marginTop={-1}>
                    |
                  </Flex>
                  <Button
                    variant="outline"
                    size="sm"
                    fontSize="md"
                    paddingX={2}
                    marginLeft={2}
                    onClick={onClickExport}
                    isLoading={isLoadingExport}
                  >
                    Exportar
                  </Button>
                </>
              )}
            </Flex>
          </ModalHeader>
          <ModalCloseButton
            top={1}
            right={1.5}
            textColor={'gray.200'}
            size="lg"
          />
          <Grid padding={4} paddingTop={4}>
            {loadingModal ? (
              <LayoutLoader
                type="modal"
                title="Recuperando informações..."
                message="Aguarde enquanto buscamos os registros no banco de dados"
              />
            ) : data?.length === 0 ? (
              <LayoutEmpty
                title="Nada encontrado!"
                message="Filtre sua busca ao lado para obter informações"
              />
            ) : (
              <>
                <TableGrid
                  id={id}
                  headers={headers}
                  query={query}
                  data={data}
                  height={'496px'}
                  itsSortable={itsSortable}
                  entity={entity}
                  actions={actions}
                  selected={true}
                  isModal={true}
                  pagination={pagination}
                  isPagedBack={isPagedBack}
                  onSelect={handlePageChange}
                  udatePageChange={udatePageChange}
                  updateIsModalConfig={updateIsModalConfig}
                  isPaged={isPaged}
                />
              </>
            )}
          </Grid>
        </ModalContent>
      </Modal>

      <ConfigColumnModal
        data={kpiModalTableStructure}
        onChange={onChange}
        isOpen={isModalConfig}
        onClose={updateIsModalConfig}
        isDisabled={isDisabled}
      />
    </>
  )
}

export default KpiModal
